import axios from "axios";
import { apiBaseUrl } from "@/services/apiClient";
import {
  getRefreshToken,
  setToken,
  setRefreshToken,
  setAccessExpiresAt,
} from "@/services/authStorage";

export class NoRefreshTokenError extends Error {
  constructor() {
    super("No refresh token available");
    this.name = "NoRefreshTokenError";
  }
}

interface RefreshResponse {
  accessToken: string;
  refreshToken: string;
  accessTokenExpiresAt: string;
  refreshTokenExpiresAt: string;
}

let inFlight: Promise<RefreshResponse> | null = null;

export async function refreshAccessToken(): Promise<RefreshResponse> {
  if (inFlight) return inFlight;
  inFlight = doRefresh().finally(() => {
    inFlight = null;
  });
  return inFlight;
}

async function doRefresh(): Promise<RefreshResponse> {
  const refreshToken = getRefreshToken();
  if (!refreshToken) throw new NoRefreshTokenError();

  // Bare axios instance (NOT apiClient) — avoids recursive 401 interception
  const { data } = await axios.post<RefreshResponse>(
    `${apiBaseUrl}/auth/refresh`,
    { refreshToken },
    { headers: { "Content-Type": "application/json" } },
  );

  setToken(data.accessToken);
  setRefreshToken(data.refreshToken);
  setAccessExpiresAt(data.accessTokenExpiresAt);
  return data;
}
